import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../../features/passport/formatCurrency';
import * as Styled from './AmountButton.styled';
import { AmountPlaceholder } from './AmountPlaceholder';
import { SuggestedTag } from './SuggestedTag';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const AmountButton = ({
  showAmountPlaceholder,
  dataId,
  activeInput,
  currencyCode,
  frequency,
  isOneBigButton,
  presetAmount,
  presetName,
  doFadeIn,
  campaignLocale,
  handleClick,
  showSuggestedTag,
  variant
}) => {
  const {
    t
  } = useTranslation('blocks.donation');
  const amount = formatCurrency({
    currencyCode,
    amount: presetAmount,
    locale: campaignLocale,
    options: {
      trailingZeroDisplay: 'stripIfInteger'
    }
  });
  return /*#__PURE__*/_jsxs(Styled.AmountButton, {
    className: "donation-amount-button",
    "data-suggested": showSuggestedTag ? 'true' : undefined,
    "data-id": dataId,
    "data-amount": presetAmount,
    type: "button",
    "aria-current": activeInput === presetName ? 'true' : 'false',
    isActive: activeInput === presetName,
    isOneBigButton: isOneBigButton,
    doFadeIn: doFadeIn,
    variant: variant,
    onClick: e => {
      e.preventDefault();
      handleClick();
    },
    children: [showSuggestedTag && /*#__PURE__*/_jsx(SuggestedTag, {}), showAmountPlaceholder ? /*#__PURE__*/_jsx(AmountPlaceholder, {
      currencyCode,
      locale: campaignLocale
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [!isOneBigButton && /*#__PURE__*/_jsx("span", {
        className: "donation-amount-label",
        children: amount
      }), isOneBigButton && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          children: t('AmountButton.frequencyDonation', {
            frequency,
            defaultValue: `${frequency} donation`
          })
        }), /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsxs("span", {
            className: "donation-amount-label",
            children: [amount, "\xA0"]
          }), /*#__PURE__*/_jsx("span", {
            children: currencyCode
          })]
        })]
      })]
    })]
  });
};